import { Injectable } from '@angular/core';
import {
  StatefulService
} from '@core/services/stateful-service-management/stateful-service-interface/stateful-service-interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TeacherService implements StatefulService {
  currentSchoolId$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor() { }

  /** Resets the stateful properties of this service. */
  reset() {
    this.currentSchoolId$.next(null);
  }
}
